import { useMutation, useQuery, useQueryClient } from 'react-query'
import {
  APICreateTransportPlannerScope,
  APIGetTransportPlannerScopeAudits,
  APIGetTransportPlannerScopes,
  APIRemoveTransportPlannerScope,
  APIUpdateTransportPlannerScope,
} from '../../service/api/APITransportPlannerScope'
import {
  CreateTransportPlannerScopePayload,
  RemoveTransportPlannerScopePayload,
  UpdateTransportPlannerScopePayload,
} from '../../compiler/transportPlannerScope.interface'

export enum ETransportPlannerScopeQueryKey {
  USER_SCOPES = 'TRANSPORT_PLANNER_USER_SCOPES',
  SCOPE_AUDITS = 'TRANSPORT_PLANNER_SCOPE_AUDITS',
}

export const useGetTransportPlannerScopes = (userUuid?: string | null) =>
  useQuery(
    [ETransportPlannerScopeQueryKey.USER_SCOPES, userUuid],
    () => APIGetTransportPlannerScopes(userUuid!, true),
    { enabled: !!userUuid, retry: 1 },
  )

export const useGetTransportPlannerScopeAudits = (scopeUuid?: string | null) =>
  useQuery(
    [ETransportPlannerScopeQueryKey.SCOPE_AUDITS, scopeUuid],
    () => APIGetTransportPlannerScopeAudits(scopeUuid!),
    { enabled: !!scopeUuid, retry: 1 },
  )

export const useCreateTransportPlannerScope = (userUuid?: string | null) => {
  const queryClient = useQueryClient()
  return useMutation(
    (payload: CreateTransportPlannerScopePayload) =>
      APICreateTransportPlannerScope(userUuid!, payload),
    {
      onSuccess: () =>
        queryClient.invalidateQueries([ETransportPlannerScopeQueryKey.USER_SCOPES, userUuid]),
    },
  )
}

export const useUpdateTransportPlannerScope = (userUuid?: string | null) => {
  const queryClient = useQueryClient()
  return useMutation(
    ({ scopeUuid, payload }: { scopeUuid: string; payload: UpdateTransportPlannerScopePayload }) =>
      APIUpdateTransportPlannerScope(scopeUuid, payload),
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries([ETransportPlannerScopeQueryKey.USER_SCOPES, userUuid])
        queryClient.invalidateQueries([
          ETransportPlannerScopeQueryKey.SCOPE_AUDITS,
          variables.scopeUuid,
        ])
      },
    },
  )
}

export const useRemoveTransportPlannerScope = (userUuid?: string | null) => {
  const queryClient = useQueryClient()
  return useMutation(
    ({ scopeUuid, payload }: { scopeUuid: string; payload: RemoveTransportPlannerScopePayload }) =>
      APIRemoveTransportPlannerScope(scopeUuid, payload),
    {
      onSuccess: () =>
        queryClient.invalidateQueries([ETransportPlannerScopeQueryKey.USER_SCOPES, userUuid]),
    },
  )
}
